import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Platform } from 'react-native';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Spacer from '../spacer';
import Text from '../text';
import Colors from '../colors';
import Icon from '../icon';
import BlankPhoto from './blank-photo';
const TYPES = {
  selfie: 'square',
  portrait: 'portrait',
  landscape: 'rectangle'
};
const StyledContainer = styled.View`
  background-color: ${Colors.black};
  opacity: 0.7;
  flex: 1;
`;
const StyleContent = styled.View`
  align-self: center;
  align-items: center;
  padding: 0 32px;
`;
const StyledInstructions = styled.View`
  align-items: flex-start;
  width: 100%;
`;
const StyledButton = styled.View`
  margin-top: auto;
  margin-bottom: ${props => props.bottom || 32}px;
  padding: 0 24px;
  width: 100%;
`;
const StyledPressable = styled.Pressable`
  width: 64px;
  border: 4px solid ${Colors.white};
  border-radius: 32px;
  align-self: center;
`;
const StyledActions = styled.View`
  flex-direction: row;
  justify-content: space-around;
`;
const StyledAction = styled(Text.BodySmall)`
  color: ${Colors.white}
  text-align: center;
  width: 164px;
`;
const StyledImage = styled.Image`
  width: 100%;
  height: 100%;
`;

function Camera(props) {
  var _props$renderCamera;

  const {
    navigation
  } = props;
  const type = TYPES[props.type || Camera.defaultProps.type];
  const [currentImage, setCurrentImage] = useState(props.currentImage);
  useLayoutEffect(() => {
    navigation.setOptions({
      title: '',
      headerTintColor: Colors.white,
      headerStyle: {
        backgroundColor: Colors.black,
        opacity: 0.7,
        borderBottomWidth: 0,
        shadowColor: 'transparent',
        shadowRadius: 0,
        shadowOffset: {
          height: 0
        }
      }
    });
  }, []);
  useEffect(() => {
    setCurrentImage(props.currentImage);
  }, [props.currentImage]);
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(StyleContent, null, /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: Colors.white,
    align: "center"
  }, currentImage ? ' ' : props.title), /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    height: true
  }), /*#__PURE__*/React.createElement(BlankPhoto, {
    type: type
  }, currentImage ? /*#__PURE__*/React.createElement(React.Fragment, null, Platform.select({
    web: /*#__PURE__*/React.createElement(StyledImage, {
      source: {
        uri: props.currentImage
      }
    }),
    default: /*#__PURE__*/React.createElement(StyledImage, {
      source: props.currentImage
    })
  })) : (_props$renderCamera = props.renderCamera) === null || _props$renderCamera === void 0 ? void 0 : _props$renderCamera.call(props)), /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    height: true
  }), /*#__PURE__*/React.createElement(StyledInstructions, null, props.instructions.map(instruction => /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: Colors.white,
    key: instruction
  }, "\u2022", ' ', instruction)))), currentImage ? /*#__PURE__*/React.createElement(StyledButton, {
    bottom: 46
  }, /*#__PURE__*/React.createElement(StyledActions, null, /*#__PURE__*/React.createElement(StyledAction, {
    weight: "bold",
    onPress: () => {
      var _props$retakePhoto;

      return (_props$retakePhoto = props.retakePhoto) === null || _props$retakePhoto === void 0 ? void 0 : _props$retakePhoto.call(props);
    }
  }, "RETAKE PHOTO"), /*#__PURE__*/React.createElement(StyledAction, {
    weight: "bold",
    onPress: () => {
      var _props$submitPhoto;

      return (_props$submitPhoto = props.submitPhoto) === null || _props$submitPhoto === void 0 ? void 0 : _props$submitPhoto.call(props);
    }
  }, "SUBMIT PHOTO"))) : /*#__PURE__*/React.createElement(StyledButton, null, /*#__PURE__*/React.createElement(StyledPressable, {
    onPress: () => {
      var _props$takePhoto;

      return (_props$takePhoto = props.takePhoto) === null || _props$takePhoto === void 0 ? void 0 : _props$takePhoto.call(props);
    }
  }, /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: "circle",
    color: Colors.white,
    size: 56
  }))));
}

Camera.propTypes = {
  navigation: PropTypes.object.isRequired,
  title: PropTypes.string,
  instructions: PropTypes.arrayOf(PropTypes.string),
  type: PropTypes.oneOf(Object.keys(TYPES)),
  currentImage: PropTypes.string,
  renderCamera: PropTypes.func,
  submitPhoto: PropTypes.func,
  takePhoto: PropTypes.func,
  retakePhoto: PropTypes.func
};
Camera.defaultProps = {
  title: '',
  instructions: ['Take the photo in a well lit area', 'Don’t use flash to prevent glare', 'Ensure that the photo is within the green box'],
  type: 'landscape',
  currentImage: null,
  renderCamera: () => null,
  submitPhoto: () => null,
  takePhoto: () => null,
  retakePhoto: () => null
};
Camera.BlankPhoto = BlankPhoto;
export default Camera;
//# sourceMappingURL=index.js.map